import { create } from 'zustand';

export interface GemXQlCacheValue<T = unknown> {
  requestId?: string;
  data?: T;
}

export type GemXQlQueryCache<T = unknown> = Record<string, GemXQlCacheValue<T>>;

export interface IGemXQlStoreState {
  queryCache: GemXQlQueryCache;
  upsertQueryCache: (key: string, value: GemXQlCacheValue) => void;
  clearQueryCache: () => void;
}

export const useGemXQlStore = create<IGemXQlStoreState>()((set, get) => ({
  queryCache: {},

  upsertQueryCache: (key, value) => {
    set((state) => ({
      queryCache: {
        ...state.queryCache,
        [key]: {
          requestId: state.queryCache[key]?.requestId ?? '',
          ...value,
        },
      },
    }));
  },

  clearQueryCache: () => {
    set({ queryCache: {} });
  },
}));
